import { useDataTransitionMain as useReorderThresholdToPurchaseOrder } from "./ReorderThresholdToPurchaseOrder/useDataTransitionMain";
import { useDataTransitionMain as useRelocateThresholdToItemRelocate } from "./RelocateThresholdToItemRelocate/useDataTransitionMain";

export default {
    useReorderThresholdToPurchaseOrder,
    useRelocateThresholdToItemRelocate
}